<template>
  <div class="step1-wrapper" v-if="application">
    <ValidationObserver
            v-slot="{ handleSubmit, invalid, dirty }"
            ref="applicantForm"
    >
      <form class="uk-form" @submit.prevent="handleSubmit(create)" autocomplete="chrome-off">
        <div class="renter-homeowner-wrapper uk-padding-top uk-margin-bottom-large" >
          <div class="uk-display-inline" >
            <span v-if="application.program.rent_program"><label class="custom" for="base-radio" style="padding-right: 15px">I am a <span class="uk-visible-small">:</span></label> <hr class="uk-visible-small"> <input type="radio" id="renter-radio" name="renter-homeowner-radio" value="renter"  v-model="submitData.mainType" :checked="!application.program.mortgage_program && application.program.rent_program"

            >
            <label class="custom" for="renter-radio">Renter</label></span>

            <span v-else><label class="custom" for="base-radio" style="padding-right: 15px">I am a <span class="uk-visible-small">:</span></label> <hr class="uk-visible-small"></span>

          </div>
          <div class="uk-display-inline uk-margin-left" v-if="application.program.mortgage_program">
            <br class="uk-visible-small"><input type="radio" id="homeowner-radio" name="renter-homeowner-radio" value="homeowner" v-model="submitData.mainType" :checked="application.program.mortgage_program && !application.program.rent_program">
            <label class="custom" for="homeowner-radio">Homeowner</label>
          </div>
        </div>

        <fieldset class="uk-margin-top">
          <legend class="">Primary Applicant</legend>
          <div class="uk-container">
            <div class="uk-grid">
              <div class="uk-width-medium-1-2 uk-margin-bottom">
                <TextInput
                        v-model="applicant.first_name"
                        name="First Name"
                        placeholder="First Name"
                        rules="required"
                        label="First Name"
                />
              </div>
              <div class="uk-width-medium-1-2 uk-margin-bottom">
                <TextInput
                        v-model="applicant.last_name"
                        name="Last Name"
                        placeholder="Last Name"
                        rules="required"
                        label="Last Name"
                />
              </div>
              <div class="uk-width-medium-1-4 uk-margin-bottom">
                <date-picker
                        name="Birthday"
                        label="Birth Date"
                        v-model="applicant.dob"
                        :config="applicantDatePickerConfig"
                        placeholder="Birth Date"
                        rules="required"
                /> <a uk-tooltip title="HOW TO ENTER YOUR BIRTHDATE" onclick="UIkit.modal.alert('<div class=\'uk-grid\'><div class=\'uk-width-1-1 uk-margin-bottom\'><h1>How to Use the Calendar Field</h1></div><div class=\'uk-width-1-2\'><h3><strong>How to enter your birth date: <ul><li>Click on the field to open the calendar.</li><li>Click on the month to select your birth month.</li><li>Double click on the year to select it, and type in your birth year.</li><li>Click on your birth day</li><li>The calendar modal will close automatically.</li></ul></h3></div><div class=\'uk-width-1-2\'><img src=\'/images/calendar-how-to.gif\'></div></div>');" class="uk-dark uk-light use-hand-cursor theme-primary-bg-color" style="position: relative; top: -55px; float: right; margin-right: 5.85px; padding: 0px; font-size: 14px; width: 20px; height: 20px; display: block; border-radius: 10px; text-align: center; color:white">?</a>
              </div>
              <div class="uk-width-medium-1-4 uk-margin-bottom">
                <label>Race:</label>
                <select v-model="applicant.race_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                  <option :value="null" selected>_</option>
                  <option v-for="item in assets.races" :value="item.id">{{item.race_desc}}</option>
                </select>
              </div>
              <div class="uk-width-medium-1-4 uk-margin-bottom">
                <label>Ethnicity:</label>
                <select v-model="applicant.ethnicity_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                  <option :value="null" selected>_</option>
                  <option v-for="item in assets.ethnicities" :value="item.id">{{item.ethnicity_desc}}</option>
                </select>
              </div>
              <div class="uk-width-medium-1-4 uk-margin-bottom">
                <label>Sex:</label>
                <select v-model="applicant.sex_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                  <option :value="null" selected>_</option>
                  <option v-for="item in assets.genders" :value="item.id">{{item.gender_desc}}</option>
                </select>
              </div>
              <div class="uk-width-medium-1-4 uk-margin-bottom">
                <label>Primary Language:</label>
                <select v-model="applicant.language_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                  <option :value="null" selected>_</option>
                  <option v-for="item in assets.languages" :value="item.id">{{item.language_desc}}</option>
                </select>
              </div>
              <div class="uk-width-medium-1-4 uk-margin-bottom">
                <label>Military Status:</label>
                <select v-model="applicant.militray_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                  <option :value="null" selected>_</option>
                  <option v-for="item in assets.militaryStatus" :value="item.id">{{item.military_status_desc}}</option>
                </select>
              </div>
              <div class="uk-width-medium-1-4 uk-margin-bottom">
                <label>Legal Status:</label>
                <select v-model="applicant.legal_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                  <option :value="null" selected>_</option>
                  <option v-for="item in assets.legalStatus" :value="item.id">{{item.legal_status_desc}}</option>
                </select>
              </div>
              <div class="uk-width-medium-1-4 uk-margin-bottom">
                <label>Education:</label>
                <select required v-model="applicant.education_id" class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                  <option :value="null" selected>_</option>
                  <option v-for="item in assets.education" :value="item.id" :selected="item.id === applicant.education_id">{{item.education_desc}}</option>
                </select>
              </div>
              <div class="uk-width-medium-1-4 uk-margin-bottom">
                <label>Disabled?:</label>
                <select v-model="applicant.disabled_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                  <option :value="null" selected>_</option>
                  <option v-for="item in assets.disabled" :value="item.id">{{item.disabled_desc}}</option>
                </select>
              </div>
              <div class="uk-width-medium-1-4 uk-margin-bottom">
                <label>Work Status:</label>
                <select v-model="applicant.work_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                  <option :value="null" selected>_</option>
                  <option v-for="item in assets.workStatus" :value="item.id">{{item.work_status_desc}}</option>
                </select>
              </div>
              <div class="uk-width-medium-1-4 uk-margin-bottom">
                <label>Disconnected Status?:</label>
                <select v-model="applicant.disconnected_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                  <option :value="null" selected>_</option>
                  <option v-for="item in assets.disconnectedStatus" :value="item.id">{{item.disconnected_statuse_desc}}</option>
                </select>
              </div>
              <div class="uk-width-medium-1-4 uk-margin-bottom">
                <label>Marital Status?:</label>
                <select v-model="applicant.marital_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                  <option :value="null" selected>_</option>
                  <option v-for="item in assets.maritalStatus" :value="item.id">{{item.marital_statuse_desc}}</option>
                </select>
              </div>
              <div class="uk-width-medium-1-4 uk-margin-bottom">
                <label>Health Insurance:</label>
                <select v-model="applicant.health_insurance_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                  <option :value="null" selected>_</option>
                  <option v-for="item in assets.healthInsurance" :value="item.id">{{item.desc}}</option>
                </select>
              </div>
              <div class="uk-width-medium-1-4 uk-margin-bottom">
                <label>Person Characteristics:</label>
                <select v-model="applicant.person_characteristic_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                  <option :value="null" selected>_</option>
                  <option v-for="item in assets.personCharacteristic" :value="item.id">{{item.desc}}</option>
                </select>
              </div>
              <div class="uk-width-medium-1-4 uk-margin-bottom">
                <label>Household Size:</label>
                <select v-model="applicant.household_size_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                  <option :value="null" selected>_</option>
                  <option v-for="item in assets.householdSize" v-if="item.household_size > 0" :value="item.id">{{item.household_size_description}}</option>
                </select>
              </div>
              <div class="uk-width-medium-1-2 uk-width-small-1-1">
                <label>SSN:</label>
                <input name="pa_ssn" v-mask="'###-##-####'" pattern="[0-9]{9}"  type="text" placeholder="Social Security Number" class="uk-width-1-1 uk-margin-bottom uk-form-large" v-model="applicant.ssn">
              </div>
              <div class="uk-width-1-1 uk-margin-bottom">
                <CustomTextarea
                        :rows="3"
                        name="Sustainable Income"
                        label="What is your plan moving forward for sustainable income to cover your housing cost?"
                        v-model="applicant.sustainable_income"
                        rules="required"
                />
              </div>
              <div class="uk-width-1-1 uk-margin-bottom">
                <CustomTextarea
                        :rows="3"
                        name="Situation"
                        label="Please explain situation and need for assistance (if COVID-19 related, please explain how)"
                        v-model="applicant.need_for_assistance"
                        rules="required"
                />
              </div>
              <template v-if="programSettings['uses-last-payment-date']">
              <div class="uk-width-small-1-1 uk-width-medium-1-2  uk-width-small-1-1 uk-margin-bottom">
                <date-picker
                        name="LastPay"
                        label="When did you last make a payment?"
                        v-model="applicant.last_pay_rent"
                        :config="datePickerConfig"
                        placeholder="Select Date"
                        rules="required"
                />
              </div>
              <div class="uk-width-small-1-1 uk-width-medium-1-2 uk-margin-bottom">
                <label>How Much did you pay?:</label>
                <TextInput
                        type="number"
                        v-model="applicant.your_pay"
                        name="Your Pay"
                        placeholder="Your Pay"
                        rules="required"
                        label="Your Pay"
                />
              </div>
              </template>
              <div class="uk-width-1-1 uk-margin-bottom">
                <label>Have you had income for the past 30 days?</label>
                <div class="uk-margin-top">
                  <label class="uk-display-inline"><input type="radio" value="1" v-model="applicant.has_income_30_days"> Yes</label>
                  <label class="uk-display-inline uk-margin-left"><input type="radio" value="0" v-model="applicant.has_income_30_days"> No</label>
                </div>
                <TextInput
                        v-if="applicant.has_income_30_days == '1'"
                        type="number"
                        v-model="applicant.income_30_days"
                        name="Amount"
                        placeholder="Amount"
                        rules="required"
                />
              </div>
              <div class="uk-width-1-1 uk-margin-bottom">
                <label>Do you have income to pay rent/mortgage going forward?</label>
                <div class="uk-margin-top">
                  <label class="uk-display-inline"><input type="radio" name="pa_rent_mortgage" value="1" v-model="applicant.rent_mortgage"> Yes</label>
                  <label class="uk-display-inline uk-margin-left"><input type="radio" name="pa_rent_mortgage" value="0" v-model="applicant.rent_mortgage"> No</label>
                </div>
              </div>
              <div class="uk-width-1-1 uk-margin-bottom">
                <label>If you aren't able to receive assistance through the HOPE Fund, will you be homeless?</label>
                <div class="uk-margin-top">
                  <label class="uk-display-inline"><input type="radio" name="pa_homeless" value="1" v-model="applicant.homeless"> Yes</label>
                  <label class="uk-display-inline uk-margin-left"><input type="radio" name="pa_homeless" value="0" v-model="applicant.homeless"> No</label>
                </div>
              </div>
            </div>
          </div>
          <hr class="uk-grid-divider uk-margin-bottom uk-margin-top app-fades" style="border:none;" >
          <legend class="app-fades">Primary Applicant's Contact Information</legend>
          <div class="uk-container" >
            <div class="uk-grid" data-uk-margin>
              <div class="uk-width-medium-5-10 uk-margin-bottom">
                <phone-number-input
                        name="Primary Phone"
                        v-model="applicant.primary_contact.formatted_number"
                        label="Primary Phone"
                        rules="required"
                />
              </div>
              <div class="uk-width-medium-5-10 uk-margin-bottom">
                <phone-number-input
                        name="Secondary Phone"
                        v-model="applicant.secondary_contact.formatted_number"
                        label="Secondary Phone"
                />
              </div>
            </div>
            <hr class="uk-grid-divider" style="clear:both; border:none" >
            <label v-if="programSettings['confidential-address-program']">
                <input type="checkbox" name="confidential_address_program" v-model="applicant.confidential_address_program">
                {{ __('tenant.confidential_address_program_desc') }}
                <br /><br />
            </label>

            <div class="uk-form-row uk-margin-bottom" >
              <p class="uk-margin-bottom-remove"><small>&nbsp;PROPERTY ADDRESS:</small></p>
              <div class="uk-grid" >
                <div class="uk-width-1-1 uk-width-medium-1-2 uk-width-small-1-1 uk-margin-small-top">
                  <TextInput
                          v-model="applicant.property_address.line_1"
                          name="Line1"
                          placeholder="Street Address"
                          rules="required"
                  />
                </div>
                <div class="uk-width-1-1 uk-width-medium-1-2 uk-width-small-1-1 uk-margin-small-top">
                  <TextInput
                          v-model="applicant.property_address.line_2"
                          name="Line2"
                          placeholder="Unit"
                  />
                </div>
                <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                  <TextInput
                          v-model="applicant.property_address.city"
                          name="City"
                          placeholder="City"
                          rules="required"
                  />
                </div>
                <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                  <select v-model="applicant.property_address.state_id" class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                    <option :value="null" selected>_</option>
                    <option v-for="item in assets.states" :value="item.id" :key="item.id">{{item.state_name}}</option>
                  </select>
                </div>
                <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                  <TextInput
                          v-model="applicant.property_address.zip"
                          name="Zip"
                          placeholder="Zip"
                          rules="required"
                  />
                </div>
              </div>
            </div>
            <br /><br />
            <label >
              <input type="checkbox" name="is_mail_address_same" onChange="$('#mailing-address').slideToggle();" class="" v-model="applicant.is_mail_address_same">
              Primary Applicant's mailing address is the same as the property address.</label>
            <div id="mailing-address" class="uk-form-row uk-margin-top" v-if="!applicant.is_mail_address_same">
              <p class="uk-margin-bottom-remove"><small>&nbsp;PRIMARY APPLICANT'S MAILING ADDRESS:</small></p>
              <div class="uk-grid" >
                <div class="uk-width-3-5 uk-width-medium-1-2 uk-width-small-1-1 uk-margin-small-top">
                  <TextInput
                          v-model="applicant.mail_address.line_1"
                          name="Line1"
                          placeholder="Street Address"
                          rules="required"
                  />
                </div>
                <div class="uk-width-3-5 uk-width-medium-1-2 uk-width-small-1-1 uk-margin-small-top">
                  <TextInput
                          v-model="applicant.mail_address.line_2"
                          name="Line2"
                          placeholder="Unit"
                  />
                </div>
                <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                  <TextInput
                          v-model="applicant.mail_address.city"
                          name="City"
                          placeholder="City"
                          rules="required"
                  />
                </div>
                <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                  <select v-model="applicant.mail_address.state_id" class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                    <option :value="null" selected>_</option>
                    <option v-for="item in assets.states" :value="item.id" :key="item.id">{{item.state_name}}</option>
                  </select>
                </div>
                <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                  <TextInput
                          v-model="applicant.mail_address.zip"
                          name="Zip"
                          placeholder="Zip"
                          rules="required"
                  />
                </div>
              </div>
            </div>
          </div>
          <br /><br />
          <div class="uk-container uk-margin-top " >
            <div class="uk-grid">
              <div class="uk-panel uk-panel-box uk-width-1-1">
                <span class="uk-panel-title"><i class="uk-icon-home uk-icon-large"></i> <u>Property Details</u></span>
                <div class="uk-panel-body">
                  <legend>The Property is:</legend>
                  <div class="uk-grid uk-margin-bottom">
                    <div class="uk-width-medium-1-1">
                      <label>
                      <input  type="checkbox" v-model="applicant.is_primary_residence" name="property-detail-residence-is" value="1" class=" xuk-form-large">
                      Applicant's Primary Residence, and is currently occupied by the applicant.</label>
                    </div>
                  </div>
                  <div id="property-unit-wrapper" v-if="submitData.mainType === 'homeowner' && applicant.is_primary_residence">
                    <legend><br />
                      The Property is:
                    </legend>
                    <div class="uk-grid uk-margin-bottom">
                      <div class="uk-width-medium-1-3 uk-margin-bottom">
                        <label >
                          <input v-model="applicant.property" type="radio" id="property-1" name="property-detail-is" value="1">
                          1 Unit</label>
                      </div>
                      <div class="uk-width-medium-1-3 uk-margin-bottom">
                        <label >
                          <input v-model="applicant.property"  type="radio" id="property-2" name="property-detail-is" value="2">
                          2 Units</label>
                      </div>
                      <div class="uk-width-medium-1-3 uk-margin-bottom">
                        <label >
                          <input v-model="applicant.property"  type="radio" id="property-3" name="property-detail-is" value="3">
                          3 Units</label>
                      </div>
                      <div class="uk-width-medium-1-3 uk-margin-bottom">
                        <label >
                          <input v-model="applicant.property"  type="radio" id="property-4" name="property-detail-is" value="4">
                          4 Units</label>
                      </div>
                      <div class="uk-width-medium-1-3  uk-margin-bottom">
                        <label >
                          <input v-model="applicant.property" value="5" type="radio" id="property-5" name="property-detail-is">
                          Manufactured or Mobile Home.</label>
                      </div>
                      <div class="uk-width-1-1 uk-text-center" v-if="applicant.property == 5">
                        <input  type="checkbox">
                        I confirm that my manufactured or mobile home is titled as real estate.</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- APPEND ADDITIONAL APPLICANTS HERE -->
          <div class="hh-member-wrapper">
            <div v-for="(member, index) in hhMembers" :key="index" class="household-memeber-form clonedInput">
              <br /><br />
              <legend class="app-fades">Household Member<span> {{ index + 2 }}</span></legend>
              <div class="uk-container " >
                <div class="uk-grid">

                  <div class="uk-width-medium-1-2 uk-margin-bottom">
                    <TextInput
                            v-model="member.first_name"
                            name="First Name"
                            placeholder="First Name"
                            label="First Name"
                            rules="required"
                    />
                  </div>
                  <div class="uk-width-medium-1-2 uk-margin-bottom">
                    <TextInput
                            v-model="member.last_name"
                            name="Last Name"
                            placeholder="Last Name"
                            label="Last Name"
                            rules="required"
                    />
                  </div>
                  <div class="uk-width-medium-5-10 ">
                    <label>Type:</label>
                    <div class="styled-select uk-margin-bottom">
                      <select v-model="member.type" class="uk-button uk-form-select uk-form-large app-type">
                        <option>_</option>
                        <option value="1">Co-borrower and/or Spouse</option>
                        <option value="2">Household Member</option>
                      </select>
                    </div>
                  </div>
                  <div class="uk-width-small-1-1 uk-width-medium-1-4">
                    <date-picker
                            name="Birthday"
                            label="Birthday"
                            v-model="member.birth_date"
                            :config="datePickerConfig"
                            placeholder="Birthday"
                            rules="required"
                    />
                  </div>
                  <div class="uk-width-medium-1-4 uk-margin-bottom">
                    <label>Race:</label>
                    <select v-model="member.race_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                      <option :value="null" selected>_</option>
                      <option v-for="item in assets.races" :value="item.id">{{item.race_desc}}</option>
                    </select>
                  </div>
                  <div class="uk-width-medium-1-4 uk-margin-bottom">
                    <label>Ethnicity:</label>
                    <select v-model="member.ethnicity_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                      <option :value="null" selected>_</option>
                      <option v-for="item in assets.ethnicities" :value="item.id">{{item.ethnicity_desc}}</option>
                    </select>
                  </div>
                  <div class="uk-width-medium-1-4 uk-margin-bottom">
                    <label>Sex:</label>
                    <select v-model="member.gender_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                      <option :value="null" selected>_</option>
                      <option v-for="item in assets.genders" :value="item.id">{{item.gender_desc}}</option>
                    </select>
                  </div>
                  <div class="uk-width-medium-1-4 uk-margin-bottom">
                    <label>Primary Language:</label>
                    <select v-model="member.primary_language_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                      <option :value="null" selected>_</option>
                      <option v-for="item in assets.languages" :value="item.id">{{item.language_desc}}</option>
                    </select>
                  </div>
                  <div class="uk-width-medium-1-4 uk-margin-bottom">
                    <label>Military Status:</label>
                    <select v-model="member.military_status_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                      <option :value="null" selected>_</option>
                      <option v-for="item in assets.militaryStatus" :value="item.id">{{item.military_status_desc}}</option>
                    </select>
                  </div>
                  <div class="uk-width-medium-1-4 uk-margin-bottom">
                    <label>Relationship to Head of Household:</label>
                    <select v-model="member.household_relationship_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                      <option :value="null" selected>_</option>
                      <option v-for="item in assets.hhRelations" :value="item.id">{{item.household_relationship_desc}}</option>
                    </select>
                  </div>
                  <div class="uk-width-medium-1-4 uk-margin-bottom">
                    <label>Legal Status:</label>
                    <select v-model="member.legal_status_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                      <option :value="null" selected>_</option>
                      <option v-for="item in assets.legalStatus" :value="item.id">{{item.legal_status_desc}}</option>
                    </select>
                  </div>
                  <div class="uk-width-medium-1-4 uk-margin-bottom">
                    <label>Education:</label>
                    <select v-model="member.education_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                      <option :value="null" selected>_</option>
                      <option v-for="item in assets.education" :value="item.id">{{item.education_desc}}</option>
                    </select>
                  </div>
                  <div class="uk-width-medium-1-4 uk-margin-bottom">
                    <label>Disabled?:</label>
                    <select v-model="member.disabled_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                      <option :value="null" selected>_</option>
                      <option v-for="item in assets.disabled" :value="item.id">{{item.disabled_desc}}</option>
                    </select>
                  </div>
                  <div class="uk-width-medium-1-4 uk-margin-bottom">
                    <label>Work Status:</label>
                    <select v-model="member.work_status_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                      <option :value="null" selected>_</option>
                      <option v-for="item in assets.workStatus" :value="item.id">{{item.work_status_desc}}</option>
                    </select>
                  </div>
                  <div class="uk-width-medium-1-4 uk-margin-bottom">
                    <label>Disconnected Status?:</label>
                    <select v-model="member.disconnected_status_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                      <option :value="null" selected>_</option>
                      <option v-for="item in assets.disconnectedStatus" :value="item.id">{{item.disconnected_statuse_desc}}</option>
                    </select>
                  </div>
                  <div class="uk-width-medium-1-4 uk-margin-bottom">
                    <label>Marital Status?:</label>
                    <select v-model="member.marital_status_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                      <option :value="null" selected>_</option>
                      <option v-for="item in assets.maritalStatus" :value="item.id">{{item.marital_statuse_desc}}</option>
                    </select>
                  </div>
                  <div class="uk-width-medium-1-4 uk-margin-bottom">
                    <label>Health Insurance:</label>
                    <select v-model="member.health_insurance_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                      <option :value="null" selected>_</option>
                      <option v-for="item in assets.healthInsurance" :value="item.id">{{item.desc}}</option>
                    </select>
                  </div>
                  <div class="uk-width-medium-1-4 uk-margin-bottom">
                    <label>Person Characteristics:</label>
                    <select v-model="member.person_characteristic_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                      <option :value="null" selected>_</option>
                      <option v-for="item in assets.personCharacteristic" :value="item.id">{{item.desc}}</option>
                    </select>
                  </div>
                </div>
                <div>
                  <a v-if="member.household_member_key != '1'" class="uk-button uk-button-mini uk-width-1-1 uk-width-medium-1-3 uk-push-2-3 uk-margin-top" @click="removeHHMember(index);"><i class="uk-icon-times"></i>REMOVE THIS MEMBER</a>
                </div>
              </div>
            </div>
          </div>
          <!-- END APPENDING APPLICANTS -->
          <br /> <br />
          <hr class="uk-grid-divider uk-margin-bottom uk-margin-top app-fades"  >
          <p id="AdditionalQualifyingApplicantQuestion" class="uk-text-center">IS THERE ANOTHER MEMBER?<br /></p>
          <div class="uk-grid uk-margin-large-bottom">

            <div class="uk-width-1-1 uk-text-center">
              <a class="uk-button uk-width-small-1-1 uk-width-medium-1-3 uk-form-large" @click="addHHMember()"><i class="uk-icon-plus-square-o" id="ApplicantYes"></i> ADD MEMBER </a>
            </div>

          </div>
        </fieldset>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
  import { mapGetters, mapState, mapMutations } from 'vuex';
  // import moment from 'moment';
  import ValidatedSection from "../../../../../components/Common/ValidatedSection";

  export default {
    name: "Step1",
    props: {
      print: {
        type: Boolean,
        default: false,
      }
    },
    components: {ValidatedSection },
    data() {
      return {
        loading: false,
        serverValidationErrors: {},
        applicantDatePickerConfig: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'M j, Y',
          altInput: true,
          dateFormat: 'Y-m-d',
          // maxDate: moment().subtract(18, 'years').toDate(),
        },
        datePickerConfig: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'M j, Y',
          altInput: true,
          dateFormat: 'Y-m-d',
        },
        submitData: {
          mainType: 'renter',
          projectName: '',
          isSameManager: true,
        }
      }
    },

    mounted() {

      if(this.application) {
        this.submitData.mainType = this.application.home_owner ? 'homeowner' : 'renter'
        this.submitData.projectName = this.application.project_name
        this.submitData.isSameManager = this.application.is_renter_same_manager
      }
    },

    watch: {
      'application': {
        handler: function(newValue, oldValue) {
          if (newValue)
          {
            this.submitData.mainType = newValue.home_owner ? 'homeowner' : 'renter'
            this.submitData.projectName = newValue.project_name
            this.submitData.isSameManager = newValue.is_renter_same_manager
          }
        },
        deep: true,
      },
      'loading': {
        handler: function(newValue, oldValue) {
          this.$isLoading(newValue)
        },
      },
      'applicant.household_size_id': {
        handler: function(newValue, oldValue) {
          if (newValue)
          {
            const hhSizeItem = this.assets.householdSize.find(item => item.id == newValue)
            let data = this.hhMembers.filter(item => item.first_name || item.last_name)
            if (hhSizeItem.household_size_key > data.length)
            {
              data = data.concat(Array.from({length: hhSizeItem.household_size_key - data.length - 1}, (x, i) => { return { type: 2 }}))
            }
            this.$store.dispatch('Application/updateHHMember', data)
          }
        },
      }
    },

    computed: {
      user() {
        return this.$store.getters['App/user']
      },
      ...mapState('Application', {
        assets: 'assets',
        application: 'application',
        applicant: 'applicant',
        hhMembers: 'hhMembers',
        renterManager: 'renterManager',
        renterOwner: 'renterOwner',
        organization: 'organization',
      }),
      ...mapGetters('Application', [ 'programSettings' ])
    },

    methods: {
      setLoading(val)
      {
        this.loading = val
      },

      removeHHMember(index) {
        this.$store.dispatch('Application/removeHHMember', index)
      },
      addHHMember() {
        this.$store.dispatch('Application/addHHMember')
      },

      scrollToErrorField() {
        const errors = Object.entries(this.$refs.applicantForm.errors)
                .map(([key, value]) => ({ key, value }))
                .filter(error => error["value"].length);
        this.$refs.applicantForm.refs[errors[0]["key"]].$el.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      },

      _getAge(birthday) {
        let dob = moment(birthday);
        let now = moment();
        return Math.abs(now.diff(dob, 'years'));
      },

      checkHHMemberAge() {
        let applicantAge = this._getAge(this.applicant.dob);
        if(applicantAge < 18) return false;
        return true;
        console.log('applicant dob ', this.applicant.dob);
        console.log('Applicant age: ' + applicantAge);
        if (applicantAge >= 18)
          return true

        const hhSizeItem = this.assets.householdSize.find(item => item.id === this.applicant.household_size_id)
        if (hhSizeItem.household_size_key === 0)
          return false

        return this.hhMembers.find(item => this._getAge(item.birth_date) >= 18)
      },

      async validateStep() {
        let stepValid = false

        // Custom Validation

        // Form Validation
        let isValid = await this.$refs.applicantForm.validate();
        if (isValid) {
          if (!this.checkHHMemberAge())
          {
            alert('The applicant must be 18 or older.')
          } else {
            stepValid = await this.submitForm()
          }
        } else {
          setTimeout(() => {
            this.scrollToErrorField()
          }, 10);
        }
        return stepValid
      },

      async submitForm() {
        let stepValid = false
        this.$emit('loading', true)

        const payload = {
          ...this.submitData,
          id: this.application.id,
          application: this.application,
          applicant: this.applicant,
          hhMembers: this.hhMembers,
          renterManager: this.renterManager,
          renterOwner: this.renterOwner,
          organization: this.organization,
        }

        await this.$store
                .dispatch(
                        this.application && this.application.id ? 'Application/update' : 'Application/create',
                        payload
                )
                .then((res) => {
                  this.$emit('done', res)
                  this.$emit('loading', false)
                  stepValid = true
                })
                .catch((err) => {
                  console.log(err.response);
                  console.log(this);
                  if (err.response.data.errors) {
                    // this.$refs.createForm.setErrors(err.response.data.errors)
                    this.serverValidationErrors = err.response.data.errors;

                  }
                  this.$emit('loading', false)
                  stepValid = false
                })

        return stepValid
      },
    }
  }
</script>

<style lang="scss">
  .step1-wrapper {
    .autocomplete-input {
      width: 100% !important;
      height: 40px !important;
      padding: 8px 6px !important;
      font-size: 16px !important;
      border-radius: 0!important;
    }
    .autocomplete-result-list {
      border-radius: 0!important;
    }
  }
</style>
